module.exports = __webpack_public_path__ + "files/399948434b2728500eaa0e1541daaa4b.png";